import { AbstractControlOptions, AsyncValidatorFn, FormGroup, ValidatorFn } from '@angular/forms';
import { LorenzFormMixin } from './lorenz-form.mixin';
import { LorenzFormPayload } from './interfaces/lorenz-control-payload.interface';

export class LorenzFormGroup extends LorenzFormMixin(FormGroup) {
	// prettier-ignore
	constructor(
		controls: { [key: string]: any },
		validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
		asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
		payload?: LorenzFormPayload
	) {
		const updateBehavior = 'change'; // 'change' | 'blur' | 'submit'

		const options: AbstractControlOptions = (() => {
			if (validatorOrOpts && typeof validatorOrOpts === 'object' && !Array.isArray(validatorOrOpts)) {
				return {
					...validatorOrOpts,
					asyncValidators: asyncValidator ?? validatorOrOpts['asyncValidators'],
					updateOn: updateBehavior
				};
			}
			return {
				validators: validatorOrOpts as ValidatorFn | ValidatorFn[] | undefined,
				asyncValidators: asyncValidator,
				updateOn: updateBehavior
			};
		})();

		super(controls, options);

		this.payload = payload ?? {};

		// console.log('LorenzFormGroup', this, this.payload);
	}
}
